import { takeEvery, all, call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { SweetAlertResult } from 'sweetalert2';
import apiService from 'app/bff/services/apiService';
import { AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyResp } from 'app/bff/models/aa/aaOtpVerify';
import { ROUTES } from 'app/core/router/paths';
import modalService from 'app/core/services/modalService';
import { ProcessRouteMatchesStep } from 'app/features/Member/Reauth/types';
import { sagaBoundary } from 'app/store/service';
import { MEMBER_REAUTH__SEND_OTP, MEMBER_REAUTH__AUTH_OTP, SendOTPAction, AuthOTPAction } from './types';
import { sendOTPDoneAction, setAccessibleStepAction } from './actions';

/**
 * @description 發送 OTP 驗證碼
 */
function * sendOTP (action: SendOTPAction) {
  const response: AaOtpSendcodeResp = yield call(apiService.postAaOtpSendcode, action.payload.args);
  if (response) {
    // 緩存 OTP 資料
    yield put(sendOTPDoneAction(response));
    // 若有轉導路由則執行導頁
    if (action.payload.redirectRoute) {
      yield put(setAccessibleStepAction(ProcessRouteMatchesStep[action.payload.redirectRoute]));
      yield put(push(action.payload.redirectRoute));
    }
  }
}

/**
 * @description 驗證 OTP 驗證碼
 */
function * authOTP (action: AuthOTPAction) {
  const response: AaOtpVerifyResp = yield call(apiService.postAaOtpVerify, action.payload.args);
  if (response) {
    const result: SweetAlertResult = yield modalService.confirm('驗證成功', '已成功驗證身分，請重新登入', '立即登入', '回首頁');
    if (result.value) {
      // 開啟會員登入 Modal
      modalService.login(true);
    }
    yield put(push(ROUTES.HOME__MAIN));
  }
}

export default function * watchReauthSaga () {
  yield all([
    takeEvery(MEMBER_REAUTH__SEND_OTP, sagaBoundary(sendOTP)),
    takeEvery(MEMBER_REAUTH__AUTH_OTP, sagaBoundary(authOTP))
  ]);
}
